import { INCLUDE_REWARDS_KEY } from '@/constants/state'
import { useMixpanel } from '@/context/mixpanel'
import { useVaultsSearchState } from '@/hooks/useVaultsSearchState'
import { useCallback } from 'react'
import { Switch, type SwitchProps } from '../common/switch'

export function RewardsFilter(props: SwitchProps) {
  const { includeRewards, updateSearchState } = useVaultsSearchState()
  const { trackEvent } = useMixpanel()

  const handleIncludeRewards = useCallback(() => {
    updateSearchState([INCLUDE_REWARDS_KEY, !includeRewards])
    trackEvent('Filter used', {
      Filter: 'rewards',
      Value: !includeRewards,
    })
  }, [trackEvent, includeRewards, updateSearchState])

  return <Switch checked={includeRewards} onCheckedChange={handleIncludeRewards} {...props} />
}
